import { Button } from "@/components/ui";
import { useRouter } from "expo-router";
import React from "react";
import { Text, View, Image } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";


export default function WelcomeScreen() {
  const router = useRouter();
  const insets = useSafeAreaInsets();
  return (
    <View
      className="flex-1 bg-background p-4"
      // HACK: This is a workaround for the SafeAreaView className prop not working
      style={{
        paddingTop: insets.top,
        paddingBottom: insets.bottom,




      }}
    >
      <View className=" items-center justify-end gap-y-4 flex-1" >
        <Image
          source={require('@/assets/images/icon.png')}
          style={{ height: 140, width: 140 }}

        />
        <Image
          source={require('@/assets/images/CrewLogo.png')}
          style={
            {
              width: 300, height: 36, objectFit: "contain", borderWidth: 1,
              borderColor: 'black', backgroundColor: 'black', borderRadius: 3

            }}
        />
      </View>

      <View className="flex-col pb-6 flex-1 justify-end gap-4" >

        <Button

          size="default"
          variant="crew"
          textClass="uppercase font-bold"

          onPress={() => {
            router.push("/sign-in");
          }}
        >
          Sign in
        </Button>
        <Button


          size="default"
          variant="ghost"
          onPress={() => {
            router.push("/sign-up");
          }}
        >
          Apply to be a Crewsader
        </Button>
      </View>

    </View>
  );
}
